import type * as THREE from 'three/webgpu';
import {shapeCircle} from 'three/tsl';
import {CameraSpriteNodeMaterial} from './CameraSpriteNodeMaterial';

/**
 * 阵列跳过选择点材质工厂。
 *
 * 职责：
 * 1. 为线性阵列与圆周草图阵列提供一致的圆形 Sprite 材质；
 * 2. 统一关闭距离衰减和深度遮挡，保证标记屏幕尺寸与可见性；
 * 3. 每次返回由调用方独占的材质，调用方必须在预览销毁时调用 `dispose()`。
 */
export class PatternSkipMarkerMaterialFactory {
    /**
     * 创建阵列跳过选择点材质。
     *
     * @param color 标记颜色。
     * @param name 便于调试与资源追踪的材质名称。
     * @returns 由调用方独占的相机感知 Sprite 材质。
     */
    public static create(
        color: THREE.ColorRepresentation,
        name: string,
    ): CameraSpriteNodeMaterial {
        const material = new CameraSpriteNodeMaterial({
            color,
            transparent: true,
            depthTest: false,
            depthWrite: false,
            sizeAttenuation: false,
            alphaToCoverage: true,
            opacityNode: shapeCircle(),
        });
        material.name = name;
        return material;
    }
}
